import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { RATINGS, ratingLabel } from './constants';

const selectedColors = {
    0: '#94a3b8',
    25: '#f87171',
    50: '#fbbf24',
    75: '#84cc16',
    100: '#10b981'
};

export default function RatingToggle({ value, onChange, disabled }) {
    // Unrated shows as NT
    const current = value ?? 0;

    return (
        <ToggleButtonGroup
            exclusive
            size="small"
            value={current}
            disabled={disabled}
            onChange={(e, selected) => {
                if (selected !== null) onChange(selected);
            }}
            // Spans the row on a phone so all five ratings fit; fixed width beside the text otherwise
            sx={{ flexShrink: 0, width: { xs: '100%', sm: 'auto' } }}
        >
            {RATINGS.map((r) => (
                <ToggleButton
                    key={r}
                    value={r}
                    sx={{
                        width: { xs: 'auto', sm: 52 },
                        flex: { xs: 1, sm: 'none' },
                        minHeight: 36,
                        padding: '4px 0',
                        fontSize: 12,
                        fontWeight: 600,
                        '&.Mui-selected, &.Mui-selected:hover': { backgroundColor: selectedColors[r], color: 'white' }
                    }}
                >
                    {ratingLabel(r)}
                </ToggleButton>
            ))}
        </ToggleButtonGroup>
    );
}
